module.exports = __webpack_public_path__ + "img/white.1072df21.svg";